<template>
  <div class="system-manage">
    <h1 class="system-manage__title">角色管理</h1>
    <div class="system-manage__card">
      <el-form :inline="true" :model="query" size="small" class="system-manage__filters" @submit.native.prevent="search">
        <el-form-item v-if="currentUser.superAdmin" label="所属主账号"><el-select v-model="query.ownerId" filterable placeholder="请选择主账号" @change="search"><el-option v-for="user in mainAccounts" :key="user.id" :label="user.realName ? user.realName + '（' + user.username + '）' : user.username" :value="user.id" /></el-select></el-form-item>
        <el-form-item label="角色名称"><el-input v-model.trim="query.name" placeholder="请输入角色名称" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="角色标识"><el-input v-model.trim="query.code" placeholder="请输入角色标识" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="query.status" placeholder="全部" clearable><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="search">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button></el-form-item>
      </el-form>
    </div>
    <div class="system-manage__card">
      <div class="system-manage__toolbar">
        <el-button v-if="can('system:role:add')" type="primary" icon="el-icon-plus" size="small" @click="openCreate">新增</el-button>
        <el-button v-if="can('system:role:delete')" type="danger" icon="el-icon-delete" size="small" :disabled="!selection.length" :loading="deleting" @click="removeRoles(selection)">删除</el-button>
      </div>
      <el-table v-loading="loading" :data="list" row-key="id" @selection-change="selection = $event">
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column label="操作" width="210" align="center"><template slot-scope="{ row }"><div class="system-manage__actions">
          <el-button v-if="can('system:role:edit')" type="text" size="small" @click="openEdit(row)">编辑</el-button>
          <el-button v-if="can('system:role:assign')" type="text" size="small" @click="openMenus(row)">分配权限</el-button>
          <el-button v-if="can('system:role:delete')" type="text" size="small" class="system-manage__danger" @click="removeRoles([row])">删除</el-button>
        </div></template></el-table-column>
        <el-table-column prop="name" label="角色名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="code" label="角色标识" min-width="150" show-overflow-tooltip />
        <el-table-column prop="description" label="角色描述" min-width="230" show-overflow-tooltip><template slot-scope="{ row }">{{ row.description || '-' }}</template></el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
        <el-table-column label="状态" width="90" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag></template></el-table-column>
        <el-table-column label="创建时间" min-width="170"><template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template></el-table-column>
      </el-table>
      <div class="system-manage__pagination"><el-pagination :current-page="pageNum" :page-size="pageSize" :total="total" :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" background @current-change="changePage" @size-change="changeSize" /></div>
    </div>

    <el-dialog :title="editingId ? '编辑角色' : '新增角色'" :visible.sync="dialogVisible" width="540px" :close-on-click-modal="false">
      <el-form ref="roleForm" :model="form" :rules="rules" label-width="90px" class="system-manage__form">
        <el-form-item label="角色名称" prop="name"><el-input v-model.trim="form.name" maxlength="64" /></el-form-item>
        <el-form-item label="角色标识" prop="code"><el-input v-model.trim="form.code" maxlength="64" placeholder="例如：dispatcher" /></el-form-item>
        <el-form-item label="角色描述" prop="description"><el-input v-model.trim="form.description" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sortOrder" :min="0" :max="99999" controls-position="right" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">禁用</el-radio></el-radio-group></el-form-item>
      </el-form>
      <p v-if="!editingId && can('system:role:assign')" class="system-manage__hint">保存后继续配置此角色的菜单与按钮权限。</p>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" v-permission="editingId ? 'system:role:edit' : 'system:role:add'" @click="save">{{ !editingId && can('system:role:assign') ? '保存并配置权限' : '确定' }}</el-button></span>
    </el-dialog>

    <el-dialog :title="'功能权限配置 · ' + target.name" :visible.sync="menuVisible" width="660px" :close-on-click-modal="false">
      <el-input v-model="menuKeyword" placeholder="输入菜单、按钮名称或权限标识" prefix-icon="el-icon-search" clearable @input="filterMenus" />
      <div class="system-manage__toolbar" style="margin-top:16px;margin-bottom:12px"><el-button size="mini" @click="checkAllMenus">全选</el-button><el-button size="mini" @click="clearMenus">清空</el-button><span class="system-manage__hint">仅可分配自己拥有的权限；菜单与按钮独立勾选，上级随下级权限一并保存。</span></div>
      <div v-loading="menusLoading" class="system-manage__tree"><el-tree ref="menuTree" :data="menuTree" node-key="id" show-checkbox check-strictly default-expand-all :props="{ label: 'name', children: 'children' }" :filter-node-method="filterMenuNode"><span slot-scope="{ data }"><i :class="data.type === 2 ? 'el-icon-key' : 'el-icon-folder-opened'" /> {{ data.name }} <span class="system-manage__hint">{{ data.permission }}</span><el-tag v-if="data.status !== 1" type="info" size="mini">禁用</el-tag></span></el-tree></div>
      <span slot="footer"><el-button @click="menuVisible = false">取消</el-button><el-button type="primary" :loading="savingMenus" :disabled="menusLoading" v-permission="'system:role:assign'" @click="saveMenus">确定</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import request from '@/utils/request'
import { getCurrentUser, hasPermission } from '@/utils/auth'

const newForm = () => ({ name: '', code: '', description: '', sortOrder: 0, status: 1 })

export default {
  name: 'InTransitRoleManage',
  data() {
    return {
      currentUser: {}, mainAccounts: [], query: { name: '', code: '', status: '', ownerId: '' },
      list: [], selection: [], total: 0, pageNum: 1, pageSize: 10, loading: false, requestId: 0,
      dialogVisible: false, editingId: null, form: newForm(), saving: false, deleting: false,
      target: {}, menuVisible: false, menusLoading: false, savingMenus: false, menuKeyword: '', menus: [], menuTree: [], menuRequestId: 0,
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入角色标识', trigger: 'blur' }, { pattern: /^[A-Za-z][A-Za-z0-9_:-]*$/, message: '请以字母开头，可包含字母、数字、下划线、冒号和短横线', trigger: 'blur' }],
        description: [{ required: true, message: '请输入角色描述', trigger: 'blur' }]
      }
    }
  },
  async created() {
    try {
      this.currentUser = await getCurrentUser()
      this.query.ownerId = this.currentUser.ownerId
      if (this.currentUser.superAdmin) { const response = await request.get('/webserver/users'); this.mainAccounts = response.data.filter(user => user.accountType === 'MAIN') }
      await this.fetchRoles()
    } catch (error) { this.$message.error(error.msg || '读取账号信息失败') }
  },
  beforeDestroy() { this.requestId += 1; this.menuRequestId += 1 },
  methods: {
    can(code) { return hasPermission(code) },
    formatDate(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
    search() { this.pageNum = 1; this.fetchRoles() },
    resetQuery() { this.query = { name: '', code: '', status: '', ownerId: this.currentUser.ownerId }; this.search() },
    changePage(page) { this.pageNum = page; this.fetchRoles() },
    changeSize(size) { this.pageSize = size; this.search() },
    async fetchRoles() {
      const id = ++this.requestId
      this.loading = true
      try {
        const response = await request.get('/webserver/system/roles', { params: { ...this.query, pageNum: this.pageNum, pageSize: this.pageSize } })
        if (id !== this.requestId) return
        this.list = response.data.items
        this.total = Number(response.data.total)
        this.selection = []
        if (!this.list.length && this.total && this.pageNum > 1) { this.pageNum -= 1; await this.fetchRoles() }
      } catch (error) { if (id === this.requestId) this.$message.error(error.msg || '读取角色失败') }
      finally { if (id === this.requestId) this.loading = false }
    },
    openCreate() { this.editingId = null; this.form = newForm(); this.dialogVisible = true; this.$nextTick(() => this.$refs.roleForm.clearValidate()) },
    openEdit(row) { this.editingId = row.id; this.form = { name: row.name, code: row.code, description: row.description, sortOrder: row.sortOrder, status: row.status }; this.dialogVisible = true; this.$nextTick(() => this.$refs.roleForm.clearValidate()) },
    save() {
      this.$refs.roleForm.validate(async valid => {
        if (!valid || this.saving) return
        this.saving = true
        try {
          const creating = !this.editingId
          const payload = { ...this.form, ownerId: this.query.ownerId }
          const response = creating ? await request.post('/webserver/system/roles', payload) : await request.put(`/webserver/system/roles/${this.editingId}`, payload)
          this.$message.success('角色已保存')
          this.dialogVisible = false
          await this.fetchRoles()
          if (creating && this.can('system:role:assign')) await this.openMenus(response.data)
        } catch (error) { this.$message.error(error.msg || '保存角色失败') }
        finally { this.saving = false }
      })
    },
    async removeRoles(rows) {
      if (this.deleting || !rows.length) return
      try {
        await this.$confirm(`确认删除选中的 ${rows.length} 个角色吗？已被用户使用的角色不能删除。`, '删除角色', { type: 'warning' })
        this.deleting = true
        for (const row of rows) await request.delete(`/webserver/system/roles/${row.id}`)
        this.$message.success('删除成功')
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '删除失败，请刷新查看已完成的操作') }
      finally { if (this.deleting) { this.deleting = false; await this.fetchRoles() } }
    },
    buildMenuTree(menus) {
      const byId = new Map(menus.map(menu => [String(menu.id), { ...menu, children: [] }]))
      const roots = []
      byId.forEach(menu => { const parent = byId.get(String(menu.parentId)); if (parent) parent.children.push(menu); else roots.push(menu) })
      return roots
    },
    async openMenus(row) {
      const id = ++this.menuRequestId
      this.target = row
      this.menuKeyword = ''
      this.menuTree = []
      this.menuVisible = true
      this.menusLoading = true
      try {
        const [menusResponse, assignedResponse] = await Promise.all([request.get('/webserver/system/menus'), request.get(`/webserver/system/roles/${row.id}/menus`)])
        if (id !== this.menuRequestId || !this.menuVisible) return
        const grantableIds = new Set(menusResponse.data.map(menu => String(menu.id)))
        if (assignedResponse.data.some(menuId => !grantableIds.has(String(menuId)))) {
          this.menuVisible = false
          this.$message.error('不能修改超过自身权限的角色')
          return
        }
        this.menus = menusResponse.data
        this.menuTree = this.buildMenuTree(this.menus)
        await this.$nextTick()
        // 独立勾选保证只授菜单访问权限时，不会自动勾选其全部按钮。
        if (id === this.menuRequestId && this.menuVisible) this.$refs.menuTree.setCheckedKeys(assignedResponse.data)
      } catch (error) { if (id === this.menuRequestId) { this.menuVisible = false; this.$message.error(error.msg || '读取权限树失败') } }
      finally { if (id === this.menuRequestId) this.menusLoading = false }
    },
    filterMenus(value) { if (this.$refs.menuTree) this.$refs.menuTree.filter(value) },
    filterMenuNode(value, data) { return !value || `${data.name} ${data.permission || ''}`.toLowerCase().includes(value.toLowerCase()) },
    checkAllMenus() { if (!this.menusLoading) this.$refs.menuTree.setCheckedKeys(this.menus.map(menu => menu.id)) },
    clearMenus() { if (!this.menusLoading) this.$refs.menuTree.setCheckedKeys([]) },
    async saveMenus() {
      if (this.savingMenus || this.menusLoading) return
      this.savingMenus = true
      try {
        const menuIds = new Set([...this.$refs.menuTree.getCheckedKeys(), ...this.$refs.menuTree.getHalfCheckedKeys()])
        const menusById = new Map(this.menus.map(menu => [String(menu.id), menu]))
        if (Array.from(menuIds).some(id => !menusById.has(String(id)))) {
          this.$message.error('不能分配自己没有的权限，请刷新后重试')
          return
        }
        // 后端要求提交所有祖先，避免子级脱离目录或菜单生效。
        Array.from(menuIds).forEach(id => {
          let parent = menusById.get(String(id))
          while (parent && parent.parentId) {
            const next = menusById.get(String(parent.parentId))
            if (!next || menuIds.has(next.id)) break
            menuIds.add(next.id)
            parent = next
          }
        })
        await request.put(`/webserver/system/roles/${this.target.id}/menus`, { menuIds: Array.from(menuIds) })
        this.$message.success('权限已保存')
        this.menuVisible = false
        await getCurrentUser(true)
      } catch (error) { this.$message.error(error.msg || '保存权限失败') }
      finally { this.savingMenus = false }
    }
  }
}
</script>

<style src="./system-manage.css"></style>
